<template>
    <InfoField :label="label" :hint="hint" :loading="loading"
            :dense="dense"
            :invalid="!!isValid"
            :message="isValid ? isValid: ''"
        >
            <slot name="inner">
                {{ value ? value : $t('Не задано')}}
            </slot>
    </InfoField>
</template>

<script>
import InfoField from '@/components/common/InfoField.vue'


export default{
    props:{
        value: String,
        label: String,
        hint: String,
        loading: Boolean,
        dense: Boolean,
        rules: Array,
    },
    data: () => ({
        error: ''
    }),
    computed:{
        isValid(){
            let valid = this.validateField()
            return valid.find(item => item != true) 
        }
    },
    methods:{
        validateField(){
            this.error = ''
            let checks = []
            if(this.rules){
                this.rules.forEach(func => {
                checks.push(func(this.value))
                })
            }
            return checks
        }
    },  
    components:{
        InfoField
    }
}
</script>